<template>
  <div class="modal fade dq-modal" id="add_section" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-header dq-modal-header">
          <div class="d-flex align-items-center gap-3">
            <span class="dq-icon-badge"><i class="ti ti-layout-grid"></i></span>
            <div class="lh-1">
              <h4 class="modal-title mb-1">Add Section</h4>
              <div class="dq-subtitle">
                Create a sub-unit under a department.
              </div>
            </div>
          </div>
          <button type="button" class="btn dq-close-btn" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleAdd">
          <div class="modal-body dq-modal-body">
            <div class="dq-form-grid">
              <div class="dq-field">
                <label class="form-label dq-label">Section Name <span class="text-danger">*</span></label>
                <input v-model="addName" type="text" class="form-control" placeholder="e.g. Accounts" required />
              </div>
              <div class="dq-field">
                <label class="form-label dq-label">Department <span class="text-danger">*</span></label>
                <div class="dropdown w-100 dq-emp-dd">
                  <button
                    id="add-section-dept-dd-btn"
                    class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                    type="button"
                    data-bs-toggle="dropdown"
                    @click="onAddDepartmentDropdownOpen"
                  >
                    <span class="text-truncate">{{ selectedAddDepartmentLabel }}</span>
                    <i class="ti ti-chevron-down ms-2"></i>
                  </button>

                  <div class="dropdown-menu p-2 w-100 shadow dq-dd-menu" @click.stop>
                    <input
                      ref="addDepartmentSearchRef"
                      v-model="addDepartmentQuery"
                      type="text"
                      class="form-control mb-2"
                      placeholder="Search department name..."
                      autocomplete="off"
                    />

                    <div class="dq-search-list">
                      <button
                        v-for="opt in filteredAddDepartments"
                        :key="opt.id"
                        type="button"
                        class="dropdown-item text-truncate dq-dd-item"
                        @click="chooseAddDepartment(opt)"
                      >
                        <div class="fw-semibold text-truncate">{{ opt.text }}</div>
                      </button>

                      <div
                        v-if="filteredAddDepartments.length === 0"
                        class="text-center py-2 small text-muted"
                      >
                        No department found
                      </div>
                    </div>

                    <div
                      class="d-flex justify-content-between align-items-center pt-2 border-top mt-2"
                    >
                      <button type="button" class="btn btn-sm btn-light" @click="clearAddDepartment">
                        Clear
                      </button>
                      <span class="small text-muted">
                        {{ filteredAddDepartments.length }} result(s)
                      </span>
                    </div>
                  </div>

                  <input
                    v-model="addDepartment"
                    type="text"
                    class="dq-hidden-required"
                    required
                    tabindex="-1"
                    aria-hidden="true"
                  />
                </div>
              </div>
              <div class="dq-field dq-status-field">
                <label class="form-label dq-label">Status <span class="text-danger">*</span></label>
                <vue-select
                  v-model="addStatus"
                  :options="statusOptions"
                  placeholder="Select status"
                  :clearable="false"
                  class="dq-vselect"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer dq-modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" :disabled="addLoading">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="addLoading">
              {{ addLoading ? "Adding…" : "Add Section" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade dq-modal" id="edit_section" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content dq-modal-card">
        <div class="modal-header dq-modal-header">
          <div class="d-flex align-items-center gap-3">
            <span class="dq-icon-badge dq-icon-badge-warn"><i class="ti ti-edit"></i></span>
            <div class="lh-1">
              <h4 class="modal-title mb-1">Edit Section</h4>
            </div>
          </div>
          <button type="button" class="btn dq-close-btn" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleEdit">
          <div class="modal-body dq-modal-body">
            <div class="dq-form-grid">
              <div class="dq-field">
                <label class="form-label dq-label">Section Name <span class="text-danger">*</span></label>
                <input v-model="editName" type="text" class="form-control" required />
              </div>
              <div class="dq-field">
                <label class="form-label dq-label">Department <span class="text-danger">*</span></label>
                <div class="dropdown w-100 dq-emp-dd">
                  <button
                    id="edit-section-dept-dd-btn"
                    class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-dd-btn"
                    type="button"
                    data-bs-toggle="dropdown"
                    @click="onEditDepartmentDropdownOpen"
                  >
                    <span class="text-truncate">{{ selectedEditDepartmentLabel }}</span>
                    <i class="ti ti-chevron-down ms-2"></i>
                  </button>

                  <div class="dropdown-menu p-2 w-100 shadow dq-dd-menu" @click.stop>
                    <input
                      ref="editDepartmentSearchRef"
                      v-model="editDepartmentQuery"
                      type="text"
                      class="form-control mb-2"
                      placeholder="Search department name..."
                      autocomplete="off"
                    />

                    <div class="dq-search-list">
                      <button
                        v-for="opt in filteredEditDepartments"
                        :key="opt.id"
                        type="button"
                        class="dropdown-item text-truncate dq-dd-item"
                        @click="chooseEditDepartment(opt)"
                      >
                        <div class="fw-semibold text-truncate">{{ opt.text }}</div>
                      </button>

                      <div
                        v-if="filteredEditDepartments.length === 0"
                        class="text-center py-2 small text-muted"
                      >
                        No department found
                      </div>
                    </div>

                    <div
                      class="d-flex justify-content-between align-items-center pt-2 border-top mt-2"
                    >
                      <button type="button" class="btn btn-sm btn-light" @click="clearEditDepartment">
                        Clear
                      </button>
                      <span class="small text-muted">
                        {{ filteredEditDepartments.length }} result(s)
                      </span>
                    </div>
                  </div>

                  <input
                    v-model="editDepartment"
                    type="text"
                    class="dq-hidden-required"
                    required
                    tabindex="-1"
                    aria-hidden="true"
                  />
                </div>
              </div>
              <div class="dq-field dq-status-field">
                <label class="form-label dq-label">Status <span class="text-danger">*</span></label>
                <vue-select
                  v-model="editStatus"
                  :options="statusOptions"
                  :clearable="false"
                  class="dq-vselect"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer dq-modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" :disabled="editLoading">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="editLoading">
              {{ editLoading ? "Saving…" : "Save Changes" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade dq-modal" id="delete_section_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content dq-modal-card">
        <div class="modal-body text-center p-4">
          <h4 class="mb-2">Delete section?</h4>
          <p class="text-muted mb-3">Employees and designations linked to this section will keep their other data; the section link is cleared.</p>
          <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" :disabled="deleteLoading">Cancel</button>
          <button type="button" class="btn btn-danger" @click="handleDelete" :disabled="deleteLoading">
            {{ deleteLoading ? "Deleting…" : "Yes, Delete" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, defineExpose, defineEmits } from "vue";
import { useDepartmentStore } from "@/stores/departmentStore";
import { useSectionStore } from "@/stores/sectionStore";

const statusOptions = ["Active", "Inactive"];
const departmentStore = useDepartmentStore();
const sectionStore = useSectionStore();
const emit = defineEmits(["refresh"]);

const departmentOptions = computed(() =>
  departmentStore.departments.map((d) => ({
    id: Number(d.id),
    text: d.name,
  })),
);

function filterDepartmentOptions(options, query) {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter((d) => (d.text || "").toLowerCase().includes(q));
}

function departmentLabel(id, fallback = "Search & select department") {
  const depId = Number(id || 0);
  if (!depId) return fallback;
  const match = departmentOptions.value.find((d) => d.id === depId);
  return match?.text || "Selected department";
}

function closeBootstrapDropdown() {
  document.body.click();
}

const addName = ref("");
const addDepartment = ref("");
const addDepartmentQuery = ref("");
const addDepartmentSearchRef = ref(null);
const addStatus = ref("Active");
const addLoading = ref(false);

const selectedAddDepartmentLabel = computed(() =>
  departmentLabel(addDepartment.value),
);

const filteredAddDepartments = computed(() =>
  filterDepartmentOptions(departmentOptions.value, addDepartmentQuery.value),
);

function chooseAddDepartment(opt) {
  addDepartment.value = String(opt.id);
  addDepartmentQuery.value = "";
  closeBootstrapDropdown();
}

function clearAddDepartment() {
  addDepartment.value = "";
  addDepartmentQuery.value = "";
}

function onAddDepartmentDropdownOpen() {
  nextTick(() => {
    addDepartmentSearchRef.value?.focus();
  });
}

async function handleAdd() {
  if (!addName.value || !addDepartment.value) return;
  addLoading.value = true;
  try {
    await sectionStore.createSection({
      name: addName.value,
      department_id: Number(addDepartment.value),
      status: addStatus.value,
    });
    addName.value = "";
    addDepartment.value = "";
    addDepartmentQuery.value = "";
    addStatus.value = "Active";
    await closeModal("add_section");
    emit("refresh");
  } catch {
    // keep modal open so the user can fix validation / API errors
  } finally {
    addLoading.value = false;
  }
}

const editId = ref(null);
const editName = ref("");
const editDepartment = ref("");
const editDepartmentQuery = ref("");
const editDepartmentSearchRef = ref(null);
const editStatus = ref("Active");
const editLoading = ref(false);

const selectedEditDepartmentLabel = computed(() =>
  departmentLabel(editDepartment.value),
);

const filteredEditDepartments = computed(() =>
  filterDepartmentOptions(departmentOptions.value, editDepartmentQuery.value),
);

function chooseEditDepartment(opt) {
  editDepartment.value = String(opt.id);
  editDepartmentQuery.value = "";
  closeBootstrapDropdown();
}

function clearEditDepartment() {
  editDepartment.value = "";
  editDepartmentQuery.value = "";
}

function onEditDepartmentDropdownOpen() {
  nextTick(() => {
    editDepartmentSearchRef.value?.focus();
  });
}

function openEditModal(record) {
  editId.value = record.id;
  editName.value = record.Section;
  editDepartment.value = record.department_id ? String(record.department_id) : "";
  editDepartmentQuery.value = "";
  editStatus.value = record.Status;
}

async function handleEdit() {
  if (!editId.value || !editName.value || !editDepartment.value) return;
  editLoading.value = true;
  try {
    await sectionStore.updateSection({
      id: editId.value,
      name: editName.value,
      department_id: Number(editDepartment.value),
      status: editStatus.value,
    });
    editId.value = null;
    editName.value = "";
    editDepartment.value = "";
    editDepartmentQuery.value = "";
    editStatus.value = "Active";
    await closeModal("edit_section");
    emit("refresh");
  } catch {
    // keep modal open so the user can fix validation / API errors
  } finally {
    editLoading.value = false;
  }
}

const deleteId = ref(null);
const deleteLoading = ref(false);

function openDeleteModal(record) {
  deleteId.value = record.id;
}

async function handleDelete() {
  if (!deleteId.value) return;
  deleteLoading.value = true;
  try {
    await sectionStore.deleteSections([deleteId.value]);
    deleteId.value = null;
    await closeModal("delete_section_modal");
    emit("refresh");
  } catch {
    // keep modal open on failure
  } finally {
    deleteLoading.value = false;
  }
}

async function closeModal(id) {
  // Close any open nested dropdown first so Bootstrap doesn't leave a stuck layer.
  closeBootstrapDropdown();

  await nextTick();

  const el = document.getElementById(id);
  if (!el) return;

  try {
    if (window.bootstrap?.Modal) {
      const instance =
        window.bootstrap.Modal.getInstance(el) ||
        window.bootstrap.Modal.getOrCreateInstance(el);
      instance.hide();
    }
  } catch {
    // fall through to DOM cleanup
  }

  // Force-clean in case hide() left backdrop / body scroll lock behind.
  el.classList.remove("show");
  el.style.display = "none";
  el.setAttribute("aria-hidden", "true");
  el.removeAttribute("aria-modal");
  el.removeAttribute("role");

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
  document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
}

onMounted(() => {
  if (!departmentStore.departments.length) departmentStore.ensureDepartments();
});

defineExpose({ openEditModal, openDeleteModal });
</script>

<style scoped>
.dq-emp-dd {
  position: relative;
}

/* Lift department picker above the Status vue-select when open */
.dq-emp-dd.show {
  z-index: 1080;
}

.dq-emp-dd .dq-dd-menu {
  z-index: 1081;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.12);
}

.dq-status-field {
  position: relative;
  z-index: 1;
}

.dq-status-field :deep(.v-select),
.dq-status-field :deep(.vs__dropdown-toggle) {
  position: relative;
  z-index: 1;
}

.dq-search-list {
  max-height: 260px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 12px;
}

.dq-dd-item {
  border-radius: 10px;
  padding: 10px 10px;
}

.dq-dd-item:active {
  background: rgba(13, 110, 253, 0.08);
}

.dq-dd-btn {
  border-radius: 12px;
}

.dq-hidden-required {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
  pointer-events: none;
}
</style>
